/**
 * External dependencies
 */

import { get } from "lodash";

export default (state) =>
  get(state, ["currentUser", "businessName"], "Untitled Business");
